import { fade, makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import GLOBAL_STYLES from '../../styles/GlobalStyles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    moreVertIcon: {
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    logoHeader: {
      width: '100px',
      height: '40px',
      cursor: 'pointer',
      paddingLeft: '12px',
      [theme.breakpoints.up('md')]: {
        width: '180px',
        height: '70px',
      },
    },
    backgroundColor: {
      background: '#212121',
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(0),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    headerMenu: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '20px',
        flexWrap: 'wrap',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    shoppingCartIconContainer: {
      width: '72px', 
      height: '64px'
    },
    shoppingCartIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '100%',
      },
    },
    sectionMobile: {
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    menu: {
      top: 'calc(63px - 16px) !important',
    },
    menuMobile: {
      top: 'calc(54px - 16px) !important',
    },
    menuItem: {
      padding: theme.spacing(0, 2, 0, 1)
    },
    menuItemLink: {
      width: '100%',
      textDecoration: 'none',
      color: GLOBAL_STYLES.secondaryColor
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawerHeader: {
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
      backgroundColor:GLOBAL_STYLES.secondaryColor,
      color:"#fff"
    },
    collapseStyle: {
      minHeight:"initial !important"
    }
  }),
);

export default useStyles;